import types from '../types/activity'
import { Map, List } from 'immutable'

const initialRoot = Map({
    notifications: List(),
    isLoading: false,
    error: '',
})

function root(state = initialRoot, action) {
    switch (action.type) {
        case types.FETCH:
            return state.merge(asyncStart())
        case types.FETCH_SUCCESS:
            return state
                .merge(asyncSuccess())
                .merge(setNotifications(action.payload.notifications))
        case types.FETCH_FAIL:
            return state.merge(asyncFail(action.payload.error))
        default:
            return state
    }
}

function asyncStart() {
    return {
        isLoading: true,
        error: '',
    }
}

function asyncSuccess() {
    return {
        isLoading: false,
        error: '',
    }
}

function asyncFail(error) {
    return {
        isLoading: false,
        error,
    }
}

function setNotifications(notifications) {
    return { notifications: List.isList(notifications) ? notifications : List(notifications) }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/activity/reducers/activity.js